import toast from 'react-hot-toast';
import { INotifyMessage, NotifyMessage } from '.';

export const Notify: {
  (message: INotifyMessage): string;
  error(message: INotifyMessage): string;
  success(message: INotifyMessage): string;
  custom(message: INotifyMessage): string;
  loading(message: INotifyMessage): string;
} = (message: INotifyMessage) =>
  toast(NotifyMessage(message));
Notify.error = (message: INotifyMessage) =>
  toast.error(NotifyMessage(message), { ...message.config });
Notify.success = (message: INotifyMessage) =>
  toast.success(NotifyMessage(message), { ...message.config });
Notify.custom = (message: INotifyMessage) =>
  toast.custom(NotifyMessage(message), { ...message.config });
Notify.loading = (message: INotifyMessage) =>
  toast.loading(NotifyMessage(message), { ...message.config });
